import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useCallback } from 'react';
export function GaugeChart({ value, max = 10, label = 'SFP', size = 160 }) {
    const canvasRef = useRef(null);
    const draw = useCallback(() => {
        const canvas = canvasRef.current;
        if (!canvas)
            return;
        const ctx = canvas.getContext('2d');
        if (!ctx)
            return;
        const dpr = window.devicePixelRatio || 1;
        canvas.width = size * dpr;
        canvas.height = size * dpr;
        canvas.style.width = `${size}px`;
        canvas.style.height = `${size}px`;
        ctx.scale(dpr, dpr);
        const cx = size / 2;
        const cy = size / 2;
        const outerRadius = size * 0.42;
        const innerRadius = size * 0.3;
        const strokeWidth = size * 0.1;
        ctx.clearRect(0, 0, size, size);
        // Background arc - brutal
        const startAngle = -Math.PI * 0.75;
        const endAngle = Math.PI * 0.75;
        ctx.beginPath();
        ctx.arc(cx, cy, (outerRadius + innerRadius) / 2, startAngle, endAngle);
        ctx.strokeStyle = '#333333';
        ctx.lineWidth = strokeWidth;
        ctx.lineCap = 'butt';
        ctx.stroke();
        // Value arc - brutal cyan
        const valueAngle = startAngle + ((value / max) * (endAngle - startAngle));
        ctx.beginPath();
        ctx.arc(cx, cy, (outerRadius + innerRadius) / 2, startAngle, valueAngle);
        ctx.strokeStyle = '#06b6d4';
        ctx.lineWidth = strokeWidth;
        ctx.lineCap = 'butt';
        ctx.stroke();
        // Value text - brutal
        ctx.fillStyle = '#f5f5f5';
        ctx.font = `900 ${size * 0.25}px "Inter", system-ui, sans-serif`;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(value.toFixed(1), cx, cy - size * 0.05);
        // Label
        ctx.fillStyle = '#999999';
        ctx.font = `700 ${size * 0.09}px "Inter", system-ui, sans-serif`;
        const labelUpper = label.toUpperCase();
        // Manual letter spacing for canvas
        const letterSpacing = size * 0.009;
        const labelWidth = ctx.measureText(labelUpper).width + (labelUpper.length - 1) * letterSpacing;
        let x = cx - labelWidth / 2;
        for (let i = 0; i < labelUpper.length; i++) {
            ctx.fillText(labelUpper[i], x, cy + size * 0.12);
            x += ctx.measureText(labelUpper[i]).width + letterSpacing;
        }
        // Min/max markers
        ctx.fillStyle = '#666666';
        ctx.font = `${size * 0.06}px "Fira Code", monospace`;
        ctx.textAlign = 'left';
        ctx.fillText('0', cx - outerRadius * 1.1, cy + size * 0.28);
        ctx.textAlign = 'right';
        ctx.fillText(max.toString(), cx + outerRadius * 1.1, cy + size * 0.28);
    }, [value, max, label, size]);
    useEffect(() => {
        draw();
    }, [draw]);
    return (_jsx("div", { className: "relative flex justify-center", children: _jsx("canvas", { ref: canvasRef, width: size, height: size }) }));
}
